<div class="schedule-first-lesson-container" [ngClass]="{ 'loading-shade': showProgressSpinner }">
  <mat-progress-spinner class="matProgressSpinnerCentered"
    *ngIf="showProgressSpinner"
    mode="indeterminate"></mat-progress-spinner>

  <div class="toggle-container mt-3" *ngIf="!hideScheduleToggle">
    <span>Schedule First Lesson</span>
    <mat-slide-toggle [ngModel]="enabled" (ngModelChange)="enabled = $event; onScheduleToggleChange()" name="scheduleToggle"></mat-slide-toggle>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger">
    <mat-icon class="error-icon">error</mat-icon>
    <span class="error-text">{{ errorMessage }}</span>
  </div>

  <div class="row mt-3" *ngIf="enabled">
    <div class="col-md-6">
      <mat-form-field class="full-width-field">
        <mat-label>Executive</mat-label>
        <mat-select [ngModel]="scheduleData.executive"
                    (ngModelChange)="onExecutiveChange($event)"
                    required>
          <mat-option>None</mat-option>
          <ng-container *ngFor="let element of _fieldsService.instructorsExecutive()">
            <mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === scheduleData.inquiryTaker)"
                      [value]="element.uid">
              {{ element.value }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-md-6">
      <mat-form-field class="full-width-field">
        <mat-label>Teacher</mat-label>
        <mat-select [ngModel]="scheduleData.teacher"
                    (ngModelChange)="onTeacherChange($event)"
                    required>
          <mat-option>None</mat-option>
          <ng-container *ngFor="let element of _fieldsService.instructorData()">
            <mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === scheduleData.teacher)"
                      [value]="element.uid">
              {{ element.value }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-md-6">
      <mat-form-field class="full-width-field">
        <mat-label>Lesson Type</mat-label>
        <mat-select [ngModel]="scheduleData.lessonType"
                    (ngModelChange)="onLessonTypeChange($event)"
                    required>
          <mat-option>None</mat-option>
          <mat-option *ngFor="let element of getFilteredLessonTypes()"
                    [value]="element.id">
            {{ element.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-md-6">
      <mat-form-field class="full-width-field">
        <input [ngModel]="field_date_and_time"
               (ngModelChange)="uiUpdateDate($event)"
               matInput
               [ngxMatDatetimePicker]="picker_field_date_time"
               placeholder="Date and Time"
               required>
        <mat-datepicker-toggle matSuffix [for]="picker_field_date_time"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #picker_field_date_time
                                [hideTime]="false"
                                [enableMeridian]="true"
                                [showSpinners]="true"
                                [showSeconds]="false"
                                [stepHour]="1"
                                [stepMinute]="15"
                                [touchUi]="false">
        </ngx-mat-datetime-picker>
      </mat-form-field>
    </div>

    <div class="col-12" *ngIf="hasConflicts">
      <div class="alert alert-warning">
        <mat-icon class="warning-icon">warning</mat-icon>
        <span class="warning-text">Schedule conflict detected. Please select a different time or instructor.</span>
      </div>
    </div>

    <div class="col-12 mt-3" *ngIf="enabled && !hideSubmitButton">
      <button type="button"
              mat-raised-button
              color="primary"
              [disabled]="disableSubmitButton || hasConflicts || !scheduleData.executive || !scheduleData.teacher || !scheduleData.lessonType || !field_date_and_time"
              (click)="submitSchedule(null)">
        Schedule Lesson
      </button>
    </div>
  </div>
</div>
